export const tabelaPremiacaoFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'nome',
      label: 'Nome',
      component: 'FormField',
      type: 'text',
      colProps: { md: 5 },
      maxLength: 255
    },
    {
      name: 'segmento',
      label: 'Segmento',
      component: 'FormField',
      type: 'text',
      colProps: { md: 5 },
      maxLength: 255
    }
  ],
  [
    {
      name: 'valorInicioFaturamento',
      label: 'Valor Início Faturamento',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'valorFinalFaturamento',
      label: 'Valor Final Faturamento',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'mediaIdeal',
      label: 'Média Ideal',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'mediaExcelente',
      label: 'Média Excelente',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'porcentagemDesconto',
      label: 'Porcentagem Desconto',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'valorPremiacao',
      label: 'Valor Premiação',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'valorPremiacaoExcelente',
      label: 'Valor Premiação Excelente',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'ativo',
      label: 'Ativo',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 3 }
    }
  ]
];

export const tabelaPremiacaoFormSections = () => [
  { title: 'Identificação', rows: [0] },
  { title: 'Faturamento e Médias', rows: [1] },
  { title: 'Premiação', rows: [2] }
];

export const validateTabelaPremiacaoForm = (values) => {
  const errors = {};

  if (!values.nome || !String(values.nome).trim()) {
    errors.nome = 'Nome e obrigatorio';
  }

  return errors;
};

export const emptyTabelaPremiacaoForm = {
  id: '',
  nome: '',
  segmento: '',
  valorInicioFaturamento: '',
  valorFinalFaturamento: '',
  mediaIdeal: '',
  mediaExcelente: '',
  porcentagemDesconto: '',
  valorPremiacao: '',
  valorPremiacaoExcelente: '',
  ativo: true
};
